module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTgwMCA2NGE2NCA2NCAwIDAgMSA2My44IDU5LjJMODY0IDEyOHY3NjhhNjQgNjQgMCAwIDEtNTkuMiA2My44TDgwMCA5NjBIMjI0YTY0IDY0IDAgMCAxLTYzLjgtNTkuMkwxNjAgODk2VjM2NS4yYTY0IDY0IDAgMCAxIDE0LjktNDEuMWwzLjgtNC4yTDQxNiA4Mi44YTY0IDY0IDAgMCAxIDM5LjYtMTguNUw0NjEuMiA2NEg4MDB6IG0wIDY0aC0yODh2MjI0YTY0IDY0IDAgMCAxLTU5LjIgNjMuOEw0NDggNDE2SDIyNHY0ODBoNTc2VjEyOHogbS0zNTIgMTMuMkwyMzcuMiAzNTJINDQ4VjE0MS4yeiIgZmlsbD0iIzAiIHAtaWQ9IjI1ODkiPjwvcGF0aD48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Document-outlined.svg
// module id = JIhw
// module chunks = 74